/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.FONT_FAMILY} parameter
 * @source
 */
var FontFamilyOptions;
(function (FontFamilyOptions) {
    FontFamilyOptions["ANDIKA"] = "andika";
    FontFamilyOptions["OPEN_DYSLEXIC"] = "open_dyslexic";
    FontFamilyOptions["ARIAL"] = "arial";
    FontFamilyOptions["COMIC_NEUE"] = "comic_neue";
    FontFamilyOptions["LUCIOLE"] = "luciole";
    FontFamilyOptions["INCLUSIVE_SANS"] = "inclusive_sans";
})(FontFamilyOptions || (FontFamilyOptions = {}));
export { FontFamilyOptions };
